import React from 'react';
import { bool, string, func, number, array } from 'prop-types';
import Table from '../../../Table/Table/Table';
import TableBody from '../../../Table/TableBody/TableBody';
import TableHeader from '../../../Table/TableHeader/TableHeader';
import ReportTableRow from './ReportTableRow';

const SORT_FIELD_MAP = {
  reportName: 'name',
  lastModifiedOn: 'lastModified',
  createdBy: 'createdByLastName',
  lastModifiedBy: 'lastModifiedByLastName',
  type: 'type',
  scope: 'scope'
};

ReportTable.propTypes = {
  createdByFilter: number,
  icon: string,
  reportBulkSelect: func,
  reports: array,
  reportWriterUrl: string,
  scopeFilter: string,
  setSortField: func,
  sortDirection: string,
  sortField: string,
  sortReportsByType: func,
  textFilter: string,
  userGroupAdmin: bool,
  userReportViewer: bool,
  userSiteAdmin: bool
};

export default function ReportTable(props) {
  function sortByColumn(event) {
    const { setSortField, sortReportsByType } = props;
    const text = event.target.innerText.toLowerCase() || event.target.parentElement.innerText.toLowerCase();

    if (text === '') return;
    let field = text ? text : event.target.parentElement.innerText.toLowerCase();
    let direction = 'ASC';

    if (field === 'report name') field = 'name';
    if (field === 'last modified on') field = 'lastModified';
    if (field === 'created by') field = 'createdByLastName';
    if (field === 'last modified by') field = 'lastModifiedByLastName';
    if (field === 'type') return sortReportsByType(getSortDirection(field));
    direction = getSortDirection(field);
    setSortField(field, direction);
  }

  function getSortDirection(field) {
    const { sortDirection, sortField } = props;

    return sortField === field && sortDirection === 'ASC' ? 'DESC' : 'ASC';
  }

  const { createdByFilter, scopeFilter, textFilter } = props;
  const columns =
    scopeFilter === 'site' ||
    scopeFilter === 'group' ||
    scopeFilter === 'internal' ||
    (scopeFilter === 'personal' && !createdByFilter) ||
    textFilter
      ? ['', 'Report name', 'Type', 'Scope', 'Created by', 'Last Modified by', 'Last Modified on']
      : ['', 'Report name', 'Type', 'Scope', 'Last Modified on'];
  const { reports, icon, sortField, userReportViewer } = props;
  return (
    <Table className="report__table">
      <TableHeader
        headerClass="report__tablehead"
        rowClass="report__headrow"
        cellClass="report__headcell"
        columns={columns}
        onClick={sortByColumn}
        icon={icon}
        sortField={sortField}
        sortFieldMap={SORT_FIELD_MAP}
      />
      <TableBody>
        {reports.map((report, index) => {
          const canModifyReport = props.userSiteAdmin || props.userGroupAdmin || report.scope.code === 'personal';

          return (
            <ReportTableRow
              key={report.id}
              id={report.id}
              userReportViewer={userReportViewer}
              userCanSelect={canModifyReport}
              url={`${props.reportWriterUrl}/${report.id}`}
              launchDarklyFeatureFlags={props.launchDarklyFeatureFlags}
              category={report.type.name}
              title={report.name}
              modified={report.lastModified}
              isFavorite={report.isFavorite}
              scopeName={report.scope.name}
              createdByName={`${report.createdBy.lastName}, ${report.createdBy.firstName} `}
              lastModifiedBy={`${report.lastModifiedBy.lastName}, ${report.lastModifiedBy.firstName} `}
              reportBulkSelect={props.reportBulkSelect}
              selected={report.selectedForEdit}
              report={report}
              columnCount={columns.length}
            />
          );
        })}
      </TableBody>
    </Table>
  );
}
